import { LabelOrDropdownComponent } from './label-or-dropdown-component/label-or-dropdown.component';
import { MatSelectModule } from '@angular/material/select';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SearchComponent } from './search-component/search.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { PageContentDisplayItemsLayoutComponent } from './layout/page-content-display-items-layout/page-content-display-items-layout.component';
import { PageSecondaryTitleComponent } from './layout/page-secondary-title/page-secondary-title.component';
import { BasicPageLayoutComponent } from './layout/basic-page-layout/basic-page-layout.component';
import { PageTitleAreaComponent } from './layout/page-title-area/page-title-area.component';
import { PageTitleComponent } from './layout/page-title/page-title.component';
import { PageSubtitleComponent } from './layout/page-subtitle/page-subtitle.component';

@NgModule({
  declarations: [
    SearchComponent,
    PageContentDisplayItemsLayoutComponent,
    PageSecondaryTitleComponent,
    BasicPageLayoutComponent,
    PageTitleAreaComponent,
    PageTitleComponent,
    PageSubtitleComponent,
    LabelOrDropdownComponent
  ],
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatSelectModule,
    MatIconModule,
    MatInputModule
  ],
  exports: [
    SearchComponent,
    PageContentDisplayItemsLayoutComponent,
    PageSecondaryTitleComponent,
    BasicPageLayoutComponent,
    PageTitleAreaComponent,
    PageTitleComponent,
    PageSubtitleComponent,
    LabelOrDropdownComponent
  ]
})
export class ResponsiveCommonModule { }
